import {useEffect, useState} from 'react';
import Script from 'next/script';
import {useDispatch, useSelector} from 'react-redux';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {Box} from '@jobseeker/lotus/foundations';
import {COOKIE_CKT} from '@constants';

import type {AppState} from '@jobseeker/common-core/types';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

export const Chat = () => {
  const isAboveLg = useIsLargeDevice('lg');
  const isAboveXL = useIsLargeDevice(1442);
  const [chatRight, setChatRight] = useState(0);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  const {
    userId,
    authInfo: {token},
  } = useSelector((state: AppState) => state.auth);

  const calculateChatRight = () => {
    const adsBanner = document.getElementById(
      'job_ads_banner_featured-institute'
    );
    const boundingBox = adsBanner?.getBoundingClientRect();
    if (boundingBox) {
      const windowWidth = window.innerWidth;
      const offsetRight = windowWidth - boundingBox?.right;
      setChatRight(offsetRight);
    }
  };

  useEffect(() => {
    calculateChatRight();
    window.addEventListener('resize', calculateChatRight);
    return () => {
      window.removeEventListener('resize', calculateChatRight);
    };
  }, []);

  const notify = (chatCount: string) => {
    try {
      dispatch({
        type: 'AppContext/set_naviagtion_location',
        payload: chatCount ?? 0,
      });
    } catch (error) {
      return;
    }
  };

  return (
    <>
      {userId && token && (
        <>
          <Box id="sticky-chat" display={{xxs: 'none', md: 'block'}} />

          <Script
            id={`${process.env.NEXT_PUBLIC_APP_NAME}-recruiter-chat`}
            dangerouslySetInnerHTML={{
              __html: `
            chatObject.stickyChat({
              theme: 'seeker-theme-one',
              userId: ${userId},
              userType: 'j',
              token: '${token}',
              tokenName:'${process.env.NEXT_PUBLIC_APP_NAME?.toUpperCase()}${COOKIE_CKT}',
              position: 'sticky',           //For jobseeker sticky chat
              offsetRight: ${
                isAboveXL
                  ? isAppIimjobs
                    ? chatRight
                    : 0
                  : isAboveLg
                  ? chatRight
                  : 0
              },
              notifyMessage: ${notify},
        })
          `,
            }}
          />
        </>
      )}
    </>
  );
};

export default Chat;

/**
 * @returns Chat widget component shown on /chats page
 */
export const Chats = () => {
  const {
    userId,
    authInfo: {token},
  } = useSelector((state: AppState) => state.auth);

  const {profile} = useSelector((state: AppState) => state.user);

  return (
    <>
      {userId && token && profile?.name && (
        <>
          <Box id="my-chat" sx={{display: 'flex', justifyContent: 'center'}} />
          <Script
            id={`${process.env.NEXT_PUBLIC_APP_NAME}-recruiter-chats`}
            dangerouslySetInnerHTML={{
              __html: `
                chatObject.myChat({
                  userId: ${userId},
                  theme: 'seeker-theme-one',
                  userType: 'j',
                  token: '${token}',
                  name: '${profile.name}',
                  tokenName:'${process.env.NEXT_PUBLIC_APP_NAME?.toUpperCase()}${COOKIE_CKT}',
                })
              `,
            }}
          />
        </>
      )}
    </>
  );
};
